{
    "search": "Sök",
    "closePanel": "Stäng panelen",
    "predefined": {
        "predefinedText": "Fördefinierad Text",
        "filter": "Filtrera",
        "blank": "<Tomma>"
    },
    "library": {
        "textLibrary": "Textbibliotek",
        "selectLanguage": "Välj språk",
        "texts": "Texter",
        "page": "Sida",
        "of": "av",
        "all": "Allt",
        "group": "Grupp",
        "language": "Språk",
        "validFrom": "Giltig från",
        "validTo": "Giltig till",
        "name": "Namn",
        "createdTime": "Skapade tid",
        "createdByUserName": "Skapad av användarnamn",
        "modifiedTime": "Ändrad tid",
        "modifiedByUserName": "Ändrad av användarnamn",
        "sortby": "Sortera efter",
        "ascending": "Stigande",
        "descending": "Nedåtgående",
        "copyText": "Kopiera text",
        "textHasExpired": "Texten är utgången.",
        "copied": "Kopierade!",
        "insertTextFromLibrary": "Infoga text från biblioteket",
        "copyFullTextToClipboard": "Tryck ENTER för att kopiera texten",
        "copyPartialTextToClipboard": "Tryck Shift + ENTER för att visa och kopiera delar av texten",
        "danish": "Danska",
        "english": "Engelska",
        "finnish": "Finska",
        "norwegian": "Norska",
        "swedish": "Svenska"
    },
    "distribution": {
        "distribution": "Distribution",
        "centralDistribution": "Central distribution",
        "localPrint": "Lokalt utskrift",
        "email": "E-post",
        "archiveOnly": "Endast arkiv",
        "successDocumentPublishment": "Dokument gick bra att publicera",
        "successDocumentDistribution": "Dokument gick bra att distributera",
        "generatingPdf": "Genererar PDF...",
        "pleaseWaitProcessing": "Vänligen vänta medan vi bearbetar din begäran.",
        "download": "Ladda ner",
        "print": "Skriv ut",
        "close": "Stäng"
    },
    "discard": {
        "discardDocument": "Makulera Dokumentet",
        "areYouSureToDiscardDocument": "Är du säker att du vill makulera dokumentet?"
    },
    "insertPoint": {
        "insertedText": "Infogad text"
    },
    "inputFieldValidation": {
        "required": "Obligatorisk",
        "atLeast": "Minst",
        "atMost": "Max",
        "characterRequired": "tecken krävs",
        "invalid": "ogiltig"
    },
    "mandatoryFieldBanner": {
        "message": "Detta dokument har obligatoriska fält som inte har fyllts i.",
        "browse": "Bläddra",
        "moveDown": "Flytta till nästa obligatoriska fält som inte har fyllts i",
        "moveUp": "Flytta till föregående obligatoriska fält som inte har fyllts i"
    },
    "breakTable": {
        "insertRowAbove": "Infoga rad ovanför",
        "insertRowBelow": "Infoga rad nedan",
        "deleteRow": "Radera rad",
        "moveUp": "Flytta upp",
        "moveDown": "Flytta ner"
    }
}